// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"contact-module--paragraph--Wy51y"};